module.exports = __webpack_public_path__ + "img/241658363001_.pic.8a7c2ace.jpg";